import SchoolRecordInput from "./SchoolRecordInput"

const StudentInformationTable = ({ register, isRead = false }) => {

    return (
        <div>
            <table className='table table-bordered table-sm align-middle'>
                <tbody>
                    <tr>
                        <td style={{ width: '15%' }}>Name</td>
                        <td style={{ width: '25%' }}>
                            <SchoolRecordInput type="text" register={register} name={'studentInfo.name'} isRead={isRead} />
                        </td>
                        <td style={{ width: '15%' }}>Nationality</td>
                        <td style={{ width: '25%' }}>
                            <SchoolRecordInput type="text" register={register} name={'studentInfo.nationality'} isRead={isRead} />
                        </td>
                        <td style={{ width: '20%' }} rowSpan={3} className='text-center'>
                            <figure style={{ width: "100%", height: "140px" }}>
                                {/* <img style={{ width: "100%", height: "100%", backgroundColor: "gray" }} /> */}
                            </figure>
                        </td>
                    </tr>
                    <tr>
                        <td>Date of Birth</td>
                        <td>
                            <SchoolRecordInput type="date" register={register} name={'studentInfo.birth'} isRead={isRead} />
                        </td>
                        <td>Gender</td>
                        <td>
                            <ul className="d-flex justify-content-center gap-3">
                                <li>
                                    <input
                                        type="radio"
                                        {...register('studentInfo.gender')}
                                        id="studentInfoGenderMale"
                                        className="form-radio me-1"
                                        value={'Male'}
                                        disabled={isRead}
                                    />
                                    <label htmlFor="studentInfoGenderMale">Male</label>
                                </li>
                                <li>
                                    <input
                                        type="radio"
                                        {...register('studentInfo.gender')}
                                        id="studentInfoGenderFemale"
                                        className="form-radio me-1"
                                        value={'Female'}
                                        disabled={isRead}
                                    />
                                    <label htmlFor="studentInfoGenderFemale">Female</label>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Entrance</td>
                        <td>
                            <SchoolRecordInput type="date" register={register} name={'studentInfo.entrance'} isRead={isRead} />
                        </td>
                        <td>Passport No.</td>
                        <td>
                            <SchoolRecordInput type="text" register={register} name={'studentInfo.passport'} isRead={isRead} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default StudentInformationTable